var React = require('react');

function ButtonCart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.3.3H1.85l.31,1.24m0,0,1.25,5m-1.25-5h9.33l-1.25,5H3.41m0,0H3.1a.94.94,0,1,0,0,1.87h7.14","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"0.6000000238418579px"},"key":0}),React.createElement("path",{"d":"M10.24,10.86a.62.62,0,1,1-.62-.62A.63.63,0,0,1,10.24,10.86Z","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"0.6000000238418579px"},"key":1}),React.createElement("path",{"d":"M4,10.86a.63.63,0,0,1-.62.63A.63.63,0,1,1,4,10.86Z","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"0.6000000238418579px"},"key":2})]);
}

ButtonCart.defaultProps = {"width":"11.79","height":"11.79","viewBox":"0 0 11.79 11.79"};

module.exports = ButtonCart;

ButtonCart.default = ButtonCart;
